
  <b-table
      class="RoutesTable"
      checkable
      :is-row-checkable="isRowCheckable"
      :checked-rows.sync="checkedRows"
      hoverable
      paginated
      backend-pagination
      :data="routes"
      :columns="columns"
      :loading="isLoading"
      :empty="!isLoading && total === 0"
      :total="total"
      :per-page="perPage"
      backend-sorting
      default-sort-direction="desc"
      :default-sort="[sortParams.field, sortParams.order]"
      @page-change="changePage"
      @sort="changeSortParams"
      @update:checkedRows="onCheckedRowsUpdate"
  >
    <template slot-scope="props">
      <!-- <b-table-column field="id">{{ props.row.id }}</b-table-column> -->

      <b-table-column field="name">
        <a href @click.prevent="$emit('route-click', props.row)" class="route-link">
					<span
              :style="`background-color: ${getColorByName(props.row.color).hex};`"
              class="route-color-preview"
              v-if="props.row.color"
          ></span>
          <!-- <i class="no-route-color" v-else>-- brak --</i> -->
          <span class="route-name">{{ props.row.name }}</span>
        </a>
      </b-table-column>

      <b-table-column field="orders" class="nowrap" :visible="currentTab !== 'new'">{{
          countRoutePoints(props.row)
        }}</b-table-column>

      <b-table-column field="createdDate">
        <div v-if="props.row.createdDate">
          {{ props.row.createdDate | humanDate }}
          <small>{{ props.row.createdDate | date('DD/MM/YYYY') }}</small>
        </div>
        <span v-else>-</span>
      </b-table-column>
    </template>
    <template slot-scope="props" slot="header">
      {{ props.column.label }}
      <i
          v-show="sortParams.field === props.column.field"
          :class="{ mdi: true, 'is-desc': sortParams.order === 'desc' }"
      >arrow_upward</i
      >
    </template>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Brak tras.</p>
        </div>
      </section>
    </template>
    <template slot="bottom-left">
      <div class="per-page">
        <span>Wyświetlaj rekordów:</span>
        <b-select @input="changePerPage($event)" :value="perPage">
          <option
              v-for="(value, index) in perPageOptions"
              :key="index"
              :value="value"
              :selected="value === perPage"
          >
            {{ value }}
          </option>
        </b-select>
      </div>
    </template>
  </b-table>
